<template>
  <div class="RwvEditModel">
    <b-form-group
      id="input-group-edit-manufacturer-name"
      label-for="input-edit-manufacturer-name"
      v-b-tooltip.hover
      title="Name">

      <b-form-input
        id="input-edit-manufacturer-name"
        v-model="manufacturer.name"
        required
        placeholder="Name">
      </b-form-input>
    </b-form-group>
    <b-button
      v-if="isModal"
      variant="outline-danger"
      v-on:click="close">
      Abbrechen
    </b-button>
    <b-button
      variant="primary"
      v-on:click="submit">
      Speichern
    </b-button>
  </div>
</template>
<script>
import { mapGetters } from "vuex"
import store from "@/store";
import {
  MANUFACTURER_PUBLISH,
  MANUFACTURER_EDIT,
  FETCH_MANUFACTURER,
  MANUFACTURER_RESET_STATE,
  FETCH_MANUFACTURERS
} from "@/store/actions.type";
export default {
  name: "RwvEditModel",
  props: {
    slug: {
      type: String,
      required: false
    },
    isModal: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      manufacturerSlug: ""
    }
  },
  created() {
    if (this.slug !== undefined) {
        store.dispatch(
        FETCH_MANUFACTURER,
        {
          slug: this.slug
        }
      );
    }
  },
  computed: {
    ...mapGetters(["manufacturer"])
  },
  methods: {
    submit() {
      var me = this;
      let action = this.manufacturer.slug ? MANUFACTURER_EDIT : MANUFACTURER_PUBLISH;
      delete me.manufacturer.carModels
      me.$store
        .dispatch(action)
        .then(({ data }) => {
          me.close()
        })
        .catch(({ response }) => {
          console.log("Error")
          console.log(response)
          me.close()
        });
    },
    close() {
      this.$emit("close")
    }
  }
}
</script>
